import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Grid2, Typography } from "@mui/material";
import AdvertisementInformation from "components/advertising/AdvertisementInformation";
import DatePickerRange from "components/common/DatePickerRange";
import SearchTextField from "components/common/SearchTextField";
import MultiOptionsSwitch from "components/common/form/MultioptionSwitch";
import CompanySelect from "components/global/CompanySelect";
import FilmAutocomplete from "components/global/FilmAutocomplete";
import FilmRatingTypes from "components/global/FilmRatingSelect";
import FilmReleaseSelect from "components/global/FilmReleaseSelect";
import { cloneDeep } from "lodash";
import log from "loglevel";
import React, { useState } from "react";
import { listStyles } from "./listStyles";
const FILM_RELEASE_TYPES = [
    {
        value: null,
        label: "All",
    },
    {
        value: 1,
        label: "Theatrical",
    },
    {
        value: 2,
        label: "Non Theater",
    },
    {
        value: 3,
        label: "Other",
    },
];

function FilmForm({ isSmallDevice, searchForm, onSearch, onSelectFilmRelease }) {
    const [form, setForm] = useState(searchForm);


    function onChangeFilmRelease(filmRelease) {




        onSelectFilmRelease(filmRelease);
    }

    function changeForm(value) {
        const newValue = value || {};
        const _form = cloneDeep(Object.assign(form, { ...newValue }));
        setForm(_form);
        onSearch(_form);
    }

    function onAdvInfoChange({ target: { value, name } }) {
        log.debug("onAdvInfoChange", name, { ...value }, typeof value);
        changeForm({
            [name]: value,
        });
    }

    const classes = listStyles();
    log.debug("****", searchForm.filmRelease);
    return (
        (<Grid2
            className={`search-grid ${isSmallDevice ? "" : classes.searchContainer}`}
            container
            spacing={2}
            style={{ maxHeight: "calc(100vh - 105px)", overflow: "auto" }}
        >
            <Grid2 size={12}>
                <Typography variant="subtitle1">Filter by release</Typography>
                <FilmReleaseSelect defaultValue={searchForm.filmRelease} onChange={onChangeFilmRelease} />
            </Grid2>
            <Grid2 size={12}>
                <FilmInformation form={form} onChange={changeForm} />
                <AdvertisementInformation
                    onChange={onAdvInfoChange}
                    defaultExpanded={false}
                    onFilmForm
                    directAdvEnteredDateStart={form.advEnteredDateStart}
                    directAdvEnteredDateEnd={form.advEnteredDateEnd}
                    style={{ padding: 0 }}
                />
            </Grid2>
        </Grid2>)
    );
}

function FilmInformation({ onChange, form }) {
    function onChangeRatingType(value) {
        onChange({ filmRating: value });
    }
    function handleSearchRatingReasons(value) {
        onChange({ filmRatingReason: value });
    }
    function onChangeFilm(film, isNoOptionValue) {
        if(!isNoOptionValue) {
            onChange({ film: null, filmName:film });
        } else {
            onChange({ film, filmName:null });
        }

    }
    function onChangeType(filmReleaseType) {
        onChange({ filmReleaseType });
    }
    function onChangeCompanySelect(company) {
        onChange({ company });
    }

    return (
        (<Accordion defaultExpanded style={{ marginBottom: 10 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant={"subtitle2"}>Advanced Search</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid2 container spacing={3}>
                    <Grid2 size={12}>
                        <CompanySelect onChange={onChangeCompanySelect} defaultValue={form.company} />
                    </Grid2>
                    <Grid2 size={12}>
                        <MultiOptionsSwitch
                            value={form.filmReleaseType}
                            options={FILM_RELEASE_TYPES}
                            onChange={onChangeType}
                        />
                    </Grid2>
                    <Grid2 size={12}>
                        {}
                        <FilmAutocomplete onChange={onChangeFilm} defaultValue={form.film} />
                    </Grid2>
                    <Grid2 size={12}>
                        <FilmRatingTypes value={form.filmRating} onChange={onChangeRatingType} />
                    </Grid2>
                    <Grid2 size={12}>
                        <SearchTextField
                            defaultValue={form.filmRatingReason || ""}
                            inputProps={{
                                label: "Rating Reason",
                                variant: "outlined",
                                name: "ratingReason",
                            }}
                            onSearch={handleSearchRatingReasons}
                        />
                    </Grid2>
                    <DatePickerRange
                        dateName="Certified"
                        fieldName="filmDateCertified"
                        start={form.filmDateCertifiedBegin}
                        end={form.filmDateCertifiedEnd}
                        onChange={onChange}
                    />
                    <DatePickerRange
                        dateName="Release"
                        fieldName="filmReleaseDate"
                        start={form.filmReleaseDateBegin}
                        end={form.filmReleaseDateEnd}
                        onChange={onChange}
                    />
                    <DatePickerRange
                        dateName="Entered"
                        fieldName="filmDateEntered"
                        start={form.filmDateEnteredBegin}
                        end={form.filmDateEnteredEnd}
                        onChange={onChange}
                    />
                </Grid2>
            </AccordionDetails>
        </Accordion>)
    );
}
export default FilmForm;
